import { render, staticRenderFns } from "./Rounds.vue?vue&type=template&id=c3c117bc&"
import script from "./Rounds.vue?vue&type=script&lang=ts&"
export * from "./Rounds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3c117bc')) {
      api.createRecord('c3c117bc', component.options)
    } else {
      api.reload('c3c117bc', component.options)
    }
    module.hot.accept("./Rounds.vue?vue&type=template&id=c3c117bc&", function () {
      api.rerender('c3c117bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/apps/Rounds.vue"
export default component.exports